/** @format */

export default {
  ua: (state) => state.common.ua,
}
